import { Box, Typography } from "@mui/material";
import { FC } from "react";
import { PiCompassBold } from "react-icons/pi";

export const ClaimNotFound: FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 300,
        height: "100%",
      }}
    >
      <Box sx={{ textAlign: "center", px: 5, py: 6 }}>
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            mx: "auto",
            mb: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background:
              "linear-gradient(135deg, rgba(39, 35, 102, 0.08), rgba(145, 88, 206, 0.18))",
          }}
        >
          <PiCompassBold size={28} color="#9158CE" />
        </Box>

        <Typography
          variant="h6"
          sx={{ fontWeight: 700, color: "text.primary" }}
        >
          Claim Not Found
        </Typography>
        <Typography sx={{ mt: 1.5, color: "text.secondary", lineHeight: 1.6 }}>
          The claim you're looking for is invalid or doesn't exist.
        </Typography>
      </Box>
    </Box>
  );
};
